import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconAsk$1 = /*@__PURE__*/ proxyCustomElement(class WppIconAsk extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-ask", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.0001 3.04169C6.1571 3.04169 3.04175 6.15704 3.04175 10C3.04175 13.843 6.1571 16.9584 10.0001 16.9584C13.8431 16.9584 16.9584 13.843 16.9584 10C16.9584 6.15704 13.8431 3.04169 10.0001 3.04169ZM1.54175 10C1.54175 5.32861 5.32867 1.54169 10.0001 1.54169C14.6715 1.54169 18.4584 5.32861 18.4584 10C18.4584 14.6714 14.6715 18.4584 10.0001 18.4584C5.32867 18.4584 1.54175 14.6714 1.54175 10ZM10.0001 15C10.4603 15 10.8334 14.6269 10.8334 14.1666C10.8334 13.7064 10.4603 13.3333 10.0001 13.3333C9.53984 13.3333 9.16675 13.7064 9.16675 14.1666C9.16675 14.6269 9.53984 15 10.0001 15ZM10 5.29169C8.55037 5.29169 7.375 6.46706 7.375 7.91669V8.12502C7.375 8.53923 7.71079 8.87502 8.125 8.87502C8.53921 8.87502 8.875 8.53923 8.875 8.12502V7.91669C8.875 7.29548 9.3788 6.79169 10 6.79169C10.6212 6.79169 11.125 7.29548 11.125 7.91669C11.125 8.38198 11.0315 8.63597 10.9376 8.79371C10.8373 8.96211 10.6985 9.08883 10.4742 9.26511C10.4521 9.28243 10.4283 9.30082 10.4032 9.32031C10.2023 9.47579 9.9116 9.70075 9.68834 10.0049C9.409 10.3855 9.25 10.8535 9.25 11.4584C9.25 11.8726 9.58579 12.2084 10 12.2084C10.4142 12.2084 10.75 11.8726 10.75 11.4584C10.75 11.1405 10.8254 10.9909 10.8976 10.8925C10.9897 10.767 11.1086 10.6738 11.3369 10.4948L11.4008 10.4446C11.6452 10.2526 11.9752 9.98316 12.2265 9.561C12.4841 9.12818 12.625 8.59723 12.625 7.91669C12.625 6.46706 11.4496 5.29169 10 5.29169Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-ask-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-ask", "wpp-icon-ask-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-ask-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-ask-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconAsk$1);
      }
      break;
  } });
}

const WppIconAsk = WppIconAsk$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconAsk, defineCustomElement };
